<template>
  <div class="register">
    <Header style="position:fixed;top:0"></Header>
    <div class="register-content">
      <div class="title">
        <h3>
          <i class="el-icon-edit" style="paddingRight:10px;color:#999"></i>填写报名表单
        </h3>
<!--        <div class="btn" @click="tologin">我已报名立即登录</div>-->
      </div>
      <div class="line"></div>
      <div class="text">
        <el-form label-position="top" class="updataUserForm" ref="form" :model="form" :rules="rules" label-width="120px">
          <el-form-item label="姓名">
            <el-input size="me" v-model="form.nickName"></el-input>
          </el-form-item>
          <el-form-item label="
                                手机号
                            ">
            <el-input class="updataInput" v-model="form.telephone">
              <el-button @click="getCode()" type="primary" slot="append">{{mes}}</el-button>
            </el-input>
          </el-form-item>
          <el-form-item label="
                                验证码
                            ">
            <el-input class="updataInput" v-model="form.authCod"></el-input>
          </el-form-item>
          <el-form-item label="
                                电子邮箱
                            ">
            <el-input class="updataInput" v-model="form.email"></el-input>
          </el-form-item>
          <el-form-item label="
                                公司/单位名称
                            ">
            <el-input v-model="form.company"></el-input>
          </el-form-item>
          <el-form-item label="职务">
            <el-input v-model="form.duty"></el-input>
          </el-form-item>
          <el-form-item label="其它职务">
            <el-input v-model="form.otherDuty"></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input
                    type="textarea"
                    :rows="10"
                    v-model="form.remark">
            </el-input>
          </el-form-item>
          <div style="display: flex;justify-content: center;">
            <el-button style="width: 170px;margin-right: 20px;" type="primary" round @click="submitForm('form')"
                       size="medium">下一步
            </el-button>
          </div>
        </el-form>
<!--        <div class="btn1" @click="tologin">我已报名立即登录</div>-->
        <CheckPhone v-if="success"></CheckPhone>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Header from '../components/Header'
import Footer from '../components/Footer'
import CheckPhone from "../components/checkPhone";
import { callApi } from "../api/callApi";
import {apiMethod} from "../global/config";
import { getToken,removeToken } from '@/utils/auth'
export default {
  components: {
    CheckPhone,Header,Footer
  },
  data() {
    return {
      mes: '获取验证码',
      form: {
        authCod:'', // 验证码
        authType:0, // 获取验证码的方式
        company: '', // 公司
        duty: '', // 职务
        email: '',  // 邮箱
        nickName: '',  // 名称
        remark: '', // 备注
        telephone: '',  // 手机号
        otherDuty: '',
      },
      rules: {
        Title: [
          {required: true, message: "请输入活动名称", trigger: "blur"},
          {min: 5, max: 30, message: "长度在 3 到 5 个字符", trigger: "blur"}
        ],
        HdxEid: [
          {required: true, message: "请输入活动报名ID", trigger: "blur"}
        ],
        time: [
          {require: true, message: "请选择预约时间段", trigger: "change"}
        ],
        Summary: [
          {required: true, message: "请输入顶部文案", trigger: "blur"}
        ],
        Description: [
          {required: true, message: "请输入底部文案", trigger: "blur"}
        ],
        SetCancelrule: [
          {required: true, message: "请选择取消规则", trigger: "change"}
        ],
        SetSubrule: [
          {required: true, message: "请选择审核规则", trigger: "change"}
        ],
        type: [
          {required: true, message: "请选择活动类型", trigger: "change"}
        ],
        peopleNumber: [
          {required: true, message: "请输入会议人数", trigger: "blur"}
        ],
        resource: [{required: true, message: "请选择", trigger: "change"}],
      },
      success: false,
    };
  },
  methods: {
    getCode () {
      let data = {
        "emailOrPhone": this.form.telephone,
        "useWay": 'email'
      }
      callApi(apiMethod.GET_HALL_CODE,data).then( (res) => {
        console.log(res);
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let data = {
            company: this.form.company,
            duty: this.form.duty,
            email: this.form.email,
            otherDuty: this.form.otherDuty,
            phone: this.form.telephone,
            realName: this.form.nickName,
            regType: 0,
            summary: this.form.remark
          }
          if(getToken()){
            callApi(apiMethod.REGISTER, this.form).then(res => {
              if(res.code === 200){
                this.success = true
              }
            });
          }else {
            callApi(apiMethod.HALL_APPLY, data).then(res => {
              if(res.code === 200 && res.data){
                this.success = true
              }
            });
          }
        } else {
          this.$message({
            message: "请补充填写您的交流信息",
            type: "error"
          });
          return false;
        }
      });
    },
    reg() {

    },
    tologin () {

    }
  }
};
</script>
<style lang="less">
  .register{
    .updataUserForm{
      .el-form-item__label{
        font-size: 15px;
        font-weight: bold;
      }
    }
  }
</style>
<style lang="less" scoped>
.register {
  width: 100%;
  height: 100%;
  .register-content {
    padding-top: 100px;
    margin: 0 auto;
    width: 1080px;
    .title {
      width: 1080px;
      height: 80px;
      line-height: 80px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #a8c3f2;
      h3 {
        margin-left: 10px;
        width: 490px;
        color: #212121;
      }
    }
    .line {
      position: absolute;
      width: 490px;
      height: 3px;
      background: rgba(33, 113, 255, 1);
    }
    .btn,
    .btn1 {
      color: #2171ff;
      font-size: 14px;
      cursor: pointer;
    }
    .text {
      margin-top: 40px;
      width: 900px;
      margin: 40px auto;
    }
    .getcode {
      display: inline-block;
      width: 120px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      background: rgba(34, 113, 255, 1);
      border-radius: 0px 8px 8px 0px;
      color: #fff;
      vertical-align: middle;
    }
    .desc {
      color: #212121;
      font-weight: 600;
      margin: 10px 0 10px 10px;
    }
    .input {
      width: 890px;
      height: 50px;
      box-sizing: border-box;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(200, 200, 200, 1);
      border-radius: 8px;
      padding: 0 10px 0 30px;
      margin: 10px;
    }
    .input1 {
      width: 770px;
      height: 50px;
      box-sizing: border-box;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(200, 200, 200, 1);
      border-radius: 8px 0 0 8px;
      border-right: none;
      padding: 0 10px 0 30px;
      margin: 10px;
      margin-right: 0;
      vertical-align: middle;
    }
    .textarea {
      width: 900px;
      height: 100px;
      box-sizing: border-box;
      border: 1px solid rgba(200, 200, 200, 1);
      border-radius: 8px;
      font-size: 14px;
    }
    .next {
      width: 300px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      background: rgba(33, 113, 255, 1);
      border-radius: 32px;
      margin: 40px auto;
      cursor: pointer;
      color: #fff;
    }
    .btn1 {
      text-align: center;
      color: #2271ff;
    }
  }
}
</style>